import React from "react";
import { store } from "redux/store";
import { emptyMessageFolder, emptySenderFolder } from "redux/index";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import makeStyles from "@mui/styles/makeStyles";
import Paper from "@mui/material/Paper";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "Calendars/Components/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Draggable from "react-draggable";
import NoButton from "Components/Buttons/NoButton";
import YesButton from "Components/Buttons/YesButton";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "10rem",
  },
  topScrollPaper: {
    height: "100vh",
    alignItems: "center",
  },
  topPaperScrollBody: {
    verticalAlign: "center",
  },
  title: {
    width: "15rem",
    fontSize: "1.2rem",
    lineHeight: "1.2rem",
    textAlign: "center",
    margin: "0 4px",
  },
  body: {
    padding: "4px",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  folderName: {
    fontSize: "1.2rem",
    color: theme.palette.text.screenTitle,
    textAlign: "center",
  },
  dialogActions: {
    display: "block",
    padding: 0,
  },
}));

const mapStateToProps = (state) => {
  return {
    logged: state.loggeduser.LoggedUser.id,
    folder: state.messagefolders.MessageFolders.find(
      (F) => F.id === state.messagefolders.selectedFolderId
    ),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    emptySenderFolder: (values) => dispatch(emptySenderFolder(values)),
    emptyMessageFolder: (values) => dispatch(emptyMessageFolder(values)),
  };
};

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} style={{ minHeight: "8rem", maxWidth: 700 }} />
    </Draggable>
  );
}

const EmptyFolder = ({
  logged,
  folder,
  folderId,
  close,
  emptyMessageFolder,
  emptySenderFolder,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  var folderName
  switch(folderId){
    case "-2":
      folderName = t("Outbox")
      break
    case "-4":
      folderName = t("Draft")
      break
    default:
      folderName = folder?.folderName
  }

  const title = () => {
    return <span className={classes.title}>{t("Empty folder")}</span>;
  };

  const body = () => {
    return (
      <>
        <div className={classes.folderName}>{folderName}</div>
        <div className={classes.body}>
          {t("Really move content of this folder to recicle bin?")}
        </div>
      </>
    );
  };

  const handleClose = () => {
    close();
  };

  const handleEmptyFolder = () => {
    if (folderId === "-2" || folderId === "-4") {
      emptySenderFolder({ userId: logged, folderId: folderId });
    } else {
      emptyMessageFolder({ userId: logged, folderId: folderId });
    }
    store.dispatch({ type: "SET_SELECTED_MESSAGE_ID", payload: "0" });
    close();
  };

  return (
    <Dialog
      classes={{
        root: classes.root,
        scrollPaper: classes.topScrollPaper,
        paperScrollBody: classes.topPaperScrollBody,
      }}
      open={true}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          handleClose();
        }
      }}
      PaperComponent={PaperComponent}
      disableEscapeKeyDown={true}
      aria-labelledby="draggable-dialog-title"
    >
      <DialogTitle
        className="dialogTitle"
        id="draggable-dialog-title"
        dialogTitle={title()}
        closeForm={handleClose}
        width="25rem"
        color="white"
        backgroundColor="#243573"
      />
      <DialogContent className="dialogContent">
        <div>{body()}</div>
      </DialogContent>
      <DialogActions className="dialogActions">
        <NoButton
          onClick={() => {
            handleClose();
          }}
        />
        <YesButton
          onClick={() => {
            handleEmptyFolder();
          }}
        />
      </DialogActions>
    </Dialog>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(EmptyFolder);
